const DeleteConfirmation = ({ t,handleDelete }) => {
  return (
    <>
      {/* <!-- Modal --> */}
      <div
        className="modal fade"
        id="my-modal"
        tabIndex="-1"
        aria-labelledby="my-modal-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content  my-modal">
            <div className="modal-body">
              <i className="fas fa-trash-alt text-danger"></i> {t("deleteConfirmation")}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-modal"
                data-bs-dismiss="modal"
                onClick={handleDelete}
              >
                {t("ok")}
              </button>
              <button
                type="button"
                className="btn-modal"
                data-bs-dismiss="modal"
              >
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteConfirmation;
